module.exports = __webpack_public_path__ + "static/chrome-b1ea7622f2149e8209b1da34eca2417b.png";